import { Pipe, PipeTransform } from '@angular/core';
import { Subject } from 'rxjs/Subject'; 

/**
 * 
 * Pipe dedicado obtener costo total de los conceptos en un servicio
 */

@Pipe({
    name: 'sumarPagos' // nombre del pipe en las directivas
})

export class SumarPagosPipe implements PipeTransform{


    // Métdodo a implementar siempre
    transform(listaPagos:any):any{
        let total=0;
        console.log(listaPagos)
        for (const key in listaPagos) {
            if (listaPagos.hasOwnProperty(key)) {
                if(listaPagos[key].estatus!='Cancelado'){
                const element = listaPagos[key];
                total= total+element.total
                }
            }
        }
	    return {total:total}
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/sumar-pagos.pipe.ts